import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (
    curPageId: string,
    formConfig: FormConfig,
    formValues: FormValues
): Promise<string | undefined> => {
    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';

        case 'dato':
            return 'beskriv-skaden';

        case 'beskriv-skaden':
            return 'cykel-godkendt-lås';

        case 'cykel-godkendt-lås':
            return 'stelnummer';

        case 'stelnummer':
            return 'genstandsregistrering';

        case 'genstandsregistrering':
            return 'om-dig';

        case 'om-dig':
            return 'andet-selskab';

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                return 'hvilket-selskab';
            }

            return 'resume';

        case 'hvilket-selskab':
            return 'resume';

        case 'resume':
            return undefined;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }
};
